/**
 * @generated SignedSource<<230d2e61bc7701d4fc87ed7aaeef6712>>
 * @relayHash 5092ed6e33bf3757d7e045f4ded60cf6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 90f597a013f86e5d9b1e6b04fcbac995002116aaec78aa0e5de42e74d0478e97

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type uiCsmWidgetConfigurationQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type uiCsmWidgetConfigurationQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly __typename: "CsmAiHub";
    readonly widgets: ReadonlyArray<{
      readonly __typename: "CsmAiWidgetConfig";
      readonly " $fragmentSpreads": FragmentRefs<"brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly " $fragmentSpreads": FragmentRefs<"brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type uiCsmWidgetConfigurationQuery = {
  response: uiCsmWidgetConfigurationQuery$data;
  variables: uiCsmWidgetConfigurationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "EMBED"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "uiCsmWidgetConfigurationQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_widgetConfigQueryReference"
                      }
                    ],
                    "type": "CsmAiWidgetConfig"
                  }
                ],
                "storageKey": "widgets(type:\"EMBED\")"
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "brandingConfigProvider_AtlassianCsmWidgetConfiguration_helpCenterBrandingQueryReference"
                  }
                ],
                "type": "HelpCenter"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uiCsmWidgetConfigurationQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "allowedDomains"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isAnonymousAccessEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isEnabled"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "position"
                      },
                      {
                        "concreteType": "CsmAiWidgetBrandingTheme",
                        "kind": "LinkedField",
                        "name": "theme",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "colorVibeVariant"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "radius"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "space"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "chatColor"
                          },
                          {
                            "concreteType": "CsmAiWidgetBrandingAttribution",
                            "kind": "LinkedField",
                            "name": "attribution",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "text"
                              },
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "CsmAiWidgetConfig"
                  }
                ],
                "storageKey": "widgets(type:\"EMBED\")"
              },
              (v5/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "primary"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fileId"
                          },
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "90f597a013f86e5d9b1e6b04fcbac995002116aaec78aa0e5de42e74d0478e97",
    "metadata": {},
    "name": "uiCsmWidgetConfigurationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6b620091915d7e69227f87a1a80ef7ac";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
